import React from "react";

const BackgroundImage = ({ heading, text, mainClass }) => {
    return (
        <div className={`service-banner ${mainClass}`}>
            <div className="service-banner-overlay"></div>
            <div className="service-banner-text-div">
                <h1>{heading}</h1>
                <p>{text}</p>
            </div>
        </div>
    )
}

export default BackgroundImage